
import { Link } from 'react-router-dom';

const InvestmentOpportunities: React.FC = () => {
  const opportunities = [
    {
      id: 4,
      title: 'Blue Ridge Mountain Haven',
      location: 'North Carolina',
      investment: '$60,000',
      expectedReturn: '20%',
      timeline: '3 years',
      image: 'https://public.readdy.ai/ai/img_res/9ba6da4142fab6093bf0440428a9239a.jpg'
    },
    {
      id: 7,
      title: 'Alabama Gulf Coast Sanctuary',
      location: 'Gulf Shores, Alabama',
      investment: '$85,000',
      expectedReturn: '23%',
      timeline: '3 years',
      image: 'https://readdy.ai/api/search-image?query=luxury%20Alabama%20Gulf%20Coast%20glamping%20investment%20property%20with%20elegant%20tiny%20homes%20near%20pristine%20white%20sand%20beaches%2C%20professional%20real%20estate%20photography%2C%20coastal%20setting%2C%20sophisticated%20beachside%20accommodations%2C%20southern%20coastal%20investment&width=400&height=300&seq=alabama-gulf&orientation=landscape'
    },
    {
      id: 6,
      title: 'Tennessee Valley Escape',
      location: 'East Tennessee',
      investment: '$70,000',
      expectedReturn: '21%',
      timeline: '4 years',
      image: 'https://readdy.ai/api/search-image?query=luxury%20Tennessee%20valley%20glamping%20investment%20property%20with%20modern%20tiny%20homes%20overlooking%20rolling%20hills%20and%20rivers%2C%20professional%20real%20estate%20photography%2C%20golden%20hour%20lighting%2C%20contemporary%20mountain%20accommodations%2C%20Smoky%20Mountains%20backdrop&width=400&height=300&seq=tennessee-valley&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Investment Opportunities
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover profitable glamping investments with strong returns and sustainable growth potential in the Southern United States.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {opportunities.map((opportunity, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="relative h-48">
                <img
                  src={opportunity.image}
                  alt={opportunity.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {opportunity.expectedReturn} ROI
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{opportunity.title}</h3>
                <p className="text-gray-600 mb-4 flex items-center">
                  <i className="ri-map-pin-line mr-2"></i>
                  {opportunity.location}
                </p>
                <div className="space-y-2 mb-6">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Min Investment:</span>
                    <span className="font-semibold">{opportunity.investment}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Timeline:</span>
                    <span className="font-semibold">{opportunity.timeline}</span>
                  </div>
                </div>
                <div className="space-y-3">
                  <Link
                    to={`/investment-detail/${opportunity.id}`}
                    className="w-full bg-emerald-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors text-center block whitespace-nowrap cursor-pointer"
                  >
                    View Details
                  </Link>
                  <Link
                    to="/start-investing"
                    className="w-full bg-white border-2 border-emerald-600 text-emerald-600 py-3 px-4 rounded-lg font-semibold hover:bg-emerald-50 transition-colors text-center block whitespace-nowrap cursor-pointer"
                  >
                    Start Investing
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/investment-packages"
            className="bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap mr-4"
          >
            View Investment Packages
          </Link>
          <Link 
            to="/investments"
            className="border border-emerald-600 text-emerald-600 px-8 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse All Opportunities
          </Link>
        </div>

      </div>
    </section>
  );
};

export default InvestmentOpportunities;
